import Cookies from 'js-cookie';

const getUserDataFromCookie = () => {
    
    try {
        return JSON.parse(Cookies.get('user_meta'))
    } catch (error) {
        return null
    }
}

export {
    getUserDataFromCookie
}